class BundlePlanTabs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initTabs();
        this.initCards();
        this.initATC();
    }

    initTabs() {
        const triggers = this.querySelectorAll("[data-tab-trigger]");
        const panels = this.querySelectorAll("[data-tab-panel]");

        if (!triggers.length || !panels.length) return;

        triggers.forEach((trigger) => {
            trigger.addEventListener("click", () => {
                const key = trigger.getAttribute("data-tab-trigger");

                triggers.forEach((btn) => {
                    btn.classList.remove("is-active");
                    btn.setAttribute("aria-selected", "false");
                });

                panels.forEach((panel) => {
                    panel.classList.remove("is-active");
                    panel.hidden = true;
                });

                trigger.classList.add("is-active");
                trigger.setAttribute("aria-selected", "true");

                const target = this.querySelector(`[data-tab-panel="${key}"]`);
                if (target) {
                    target.classList.add("is-active");
                    target.hidden = false;
                }
            });
        });
    }

    initATC() {
        const forms = this.querySelectorAll(".bundle-plan-atc-form");

        forms.forEach((form) => {
            const button = form.querySelector('button[type="submit"]');

            if (!button) return;

            form.addEventListener("submit", () => {
                button.classList.add("is-loading");
                button.setAttribute("disabled", "disabled");

                setTimeout(() => {
                    button.classList.remove("is-loading");
                    button.removeAttribute("disabled");
                }, 5000);
            });
        });
    }

    initCards() {
        const labels = {
            oneTime: this.dataset.oneTimeLabel || "ONE-TIME PURCHASE",
            subscribe: this.dataset.subscribeLabel || "SUBSCRIBE & SAVE"
        };

        const cards = this.querySelectorAll("[data-card]");

        cards.forEach((card) => {
            const hasSubscription = card.dataset.hasSubscription === "true";
            const toggle = card.querySelector("[data-plan-toggle]");

            if (!hasSubscription || !toggle) return;

            const initialMode =
                card.dataset.initialMode === "subscribe" ? "subscribe" : "one-time";

            this.updateCard(card, initialMode, labels);

            toggle.addEventListener("click", () => {
                const currentMode =
                    toggle.dataset.mode === "subscribe" ? "subscribe" : "one-time";

                const nextMode = currentMode === "subscribe" ? "one-time" : "subscribe";
                this.updateCard(card, nextMode, labels);
            });
        });
    }

    updateCard(card, mode, labels) {
        const isSubscribe = mode === "subscribe";

        const currentPrice = card.querySelector("[data-current-price]");
        const currentPer = card.querySelector("[data-current-per]");
        const saveWrap = card.querySelector("[data-save-wrap]");
        const savePrice = card.querySelector("[data-save-price]");
        const comparePrice = card.querySelector("[data-compare-price]");
        const compareWrap = card.querySelector("[data-compare-wrap]");
        const toggleLabel = card.querySelector("[data-toggle-label]");
        const togglePrice = card.querySelector("[data-toggle-price]");
        const toggle = card.querySelector("[data-plan-toggle]");
        const atcPrice = card.querySelector("[data-atc-price]");
        const sellingPlanInput = card.querySelector("[data-selling-plan-input]");

        const oneTimePrice = card.dataset.oneTimePrice || "";
        const subscribePrice = card.dataset.subscribePrice || "";
        const oneTimePer = card.dataset.oneTimePer || "";
        const subscribePer = card.dataset.subscribePer || "";
        const oneTimeSave = card.dataset.oneTimeSave || "";
        const subscribeSave = card.dataset.subscribeSave || "";
        const compare = card.dataset.comparePrice || "";
        const oneTimeCompare = card.dataset.oneTimeComparePrice || "";
        const subscribeCompare = card.dataset.subscribeComparePrice || compare || "";
        const sellingPlanId = card.dataset.sellingPlanId || "";

        const cleanPrice = (value) => {
            return parseFloat(String(value || "").replace(/[^0-9.]/g, "")) || 0;
        };

        const getSavePercent = (compareValue, priceValue, fallbackSave = "") => {
            const compareNum = cleanPrice(compareValue);
            const priceNum = cleanPrice(priceValue);

            if (compareNum > priceNum && priceNum > 0) {
                const percent = ((compareNum - priceNum) / compareNum) * 100;
                return this.dataset.savingsPrecision === "2" ? Number(percent.toFixed(2)) : Math.round(percent);
            }

            const fallbackNum = parseFloat(fallbackSave) || 0;
            return fallbackNum > 0 ? fallbackNum : 0;
        };

        const activePrice = isSubscribe ? subscribePrice : oneTimePrice;
        const activePer = isSubscribe ? subscribePer : oneTimePer;
        const activeCompare = isSubscribe ? subscribeCompare : oneTimeCompare;

        const activeSave = isSubscribe
            ? getSavePercent(subscribeCompare, subscribePrice, subscribeSave)
            : getSavePercent(oneTimeCompare, oneTimePrice, oneTimeSave);

        if (currentPrice) {
            currentPrice.textContent = activePrice;
        }

        if (currentPer) {
            currentPer.textContent = activePer;
        }

        if (savePrice) {
            savePrice.textContent = activeSave > 0 ? `${activeSave}%` : "";
        }

        if (saveWrap) {
            saveWrap.hidden = activeSave <= 0;
        }

        if (comparePrice) {
            comparePrice.textContent = activeCompare;
        }

        if (compareWrap) {
            const compareNum = cleanPrice(activeCompare);
            const priceNum = cleanPrice(activePrice);
            compareWrap.hidden = compareNum <= priceNum;
        }

        if (toggleLabel) {
            toggleLabel.textContent = isSubscribe ? labels.oneTime : labels.subscribe;
        }

        if (togglePrice) {
            togglePrice.textContent = isSubscribe ? oneTimePrice : subscribePrice;
        }

        if (atcPrice) {
            atcPrice.textContent = activePrice;
        }

        if (sellingPlanInput) {
            sellingPlanInput.value = isSubscribe ? sellingPlanId : "";
        }

        if (toggle) {
            toggle.dataset.mode = mode;
            toggle.setAttribute("aria-pressed", isSubscribe ? "true" : "false");
        }

        this.toggleLists(card, mode);
    }

    toggleLists(card, mode) {
        const lists = card.querySelectorAll("[data-plan-content]");

        lists.forEach((list) => {
            const listMode = list.dataset.planContent;
            list.classList.toggle("is-active", listMode === mode);
        });
    }
}

if (!customElements.get("bundle-plan-tabs")) {
    customElements.define("bundle-plan-tabs", BundlePlanTabs);
}

document.addEventListener("shopify:section:load", (event) => {
    const el = event.target.querySelector("bundle-plan-tabs");
    if (el) {
        el.connectedCallback();
    }
});